import { Component } from 'preact';
import PropTypes from 'prop-types';

export class MobileStepsProgress extends Component {
  render() {
    const { currentStep, stepsCount } = this.props;

    return (
      <section className="mobile-steps-progess">
        {currentStep}/{stepsCount}
      </section>
    );
  }
}

MobileStepsProgress.propTypes = {
  currentStep: PropTypes.number,
  stepsCount: PropTypes.number,
};
